import * as Sentry from '@sentry/browser';
import Cookies from 'js-cookie';
import { PRIVATIZATION, ENV_CONFIG } from '@meiqia/constants';
import { init, makeFetchTransport, makeMultiplexedTransport, replayIntegration } from '@sentry/browser';

if (process.env.NODE_ENV !== 'development' && !PRIVATIZATION.IS_PRIVATIZATION) {
  const sentryTargets = {
    default: {
      // identification: 'webpack-internal',
      // dsn: 'https://2922d3cc3a1247f39851f8571b9b8ab6@frontend-sentry.meiqia.com/15',
      identification: 'fe-workbench',
      dsn: 'https://32f8e2050cb9401b86491ca04220b4c7@frontend-sentry.meiqia.com/3',
      release: ENV_CONFIG.runVersion
    },
    micros: {
      // identification: 'localhost:9007',
      // dsn: 'https://be5985cbe6d040c38003393bac87cd06@frontend-sentry.meiqia.com/11',
      identification: 'dashboard-miro-apps',
      dsn: 'https://f29a76f3bd4a41bc96772664d8d59706@frontend-sentry.meiqia.com/14',
      release: window.runTimeVersion
    }
  };

  const customTransport = makeMultiplexedTransport(makeFetchTransport, args => {
    const event = args.getEvent();
    let sentryObj = { dsn: sentryTargets.default.dsn, release: sentryTargets.default.release };
    const frameValues = event.exception?.values?.[0];
    if (frameValues?.stacktrace?.frames) {
      const frames = frameValues.stacktrace.frames;
      for (const targetKey in sentryTargets) {
        const target = sentryTargets[targetKey];
        const framesPath = frames
          .slice(-1)
          ?.filter(frame => frame.filename && frame.filename.includes(target.identification));
        if (framesPath.length) {
          const filename = framesPath?.[0]?.filename;
          const regex = new RegExp(`${target.identification}\/([^\/]+)\/js`);
          const match = filename.match(regex);
          sentryObj = {
            release: match?.[1] || target.release || '',
            dsn: target.dsn
          };
        }
      }
    }
    return [sentryObj];
  });

  init({
    dsn: sentryTargets.default.dsn,
    integrations: [replayIntegration()],
    transport: customTransport,
    ignoreErrors: [
      'Loading CSS chunk',
      'NotAllowedError',
      'ChunkLoadError',
      'Request failed with status code 4',
      'Non-Error promise rejection',
      'ResizeObserver loop completed with undelivered notifications.',
      'ResizeObserver loop limit exceeded',
      'AbortError',
      'process is not defined',
      "Cannot read properties of null (reading 'postMessage')",
      "Cannot read property 'postMessage' of null"
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['app.meiqia.com', 'app-test.meiqia.com'],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: ENV_CONFIG.runEnv,
    autoSessionTracking: false
  });
  const data = {
    entName: Cookies.get('_enterpriseName'),
    entId: Cookies.get('_enterprise_id'),
    agentId: Cookies.get('_agent_id'),
    version: ENV_CONFIG.runVersion,
    env: ENV_CONFIG.runEnv
  };

  Sentry.setTags(data);
  if (window.returnCitySN) {
    Sentry.setUser({ ip_address: window.returnCitySN.cip, cname: window.returnCitySN.cname });
  }
  Sentry.setContext('character', data);
}
